import React from "react";

import cx from "classnames";

import ArrowDropdown, { DropdownItem } from "~/ui/ArrowDropdown";

import styles from "./WeightInput.module.css";

const OBJECTIVE_VALID_WEIGHTS = [4, 3, 2, 1, 0, 0.5, 0.25];
const KEY_RESULT_VALID_WEIGHTS = [4, 3, 2, 1, 0.5, 0.25];

interface WeightInputProps {
	weight: number;
	onChange: (newWeight: number) => void;
	isKeyResult?: boolean;
	className?: string;
	disabled?: boolean;
}

export default function WeightInput({ weight, onChange, isKeyResult, className, disabled }: WeightInputProps) {
	const validWeights = isKeyResult ? KEY_RESULT_VALID_WEIGHTS : OBJECTIVE_VALID_WEIGHTS;
	const handleChange = React.useCallback(
		(newWeight: number) => () => {
			onChange(newWeight);
		},
		[onChange],
	);

	return (
		<ArrowDropdown
			compact
			hideArrow
			forceCloseOnOutsideClick
			heading="Select weight"
			text={`${weight}x`}
			className={cx(styles.weightSelection, className)}
			disabled={disabled}
		>
			{validWeights.map(validWeight => (
				<DropdownItem key={`weight-${validWeight}`} onClick={handleChange(validWeight)}>
					{validWeight}x
				</DropdownItem>
			))}
		</ArrowDropdown>
	);
}
